import { tx } from '@transifex/native';

/**
 * Initialize client-side Transifex Native instance cache
 */
export function setClientSideTranslations({ locale, translations }) {
  if (!locale || !translations) return;
  tx.init({
    currentLocale: locale,
  });
  tx.cache.update(locale, translations);
}
